<template>
  <div class="input-border" @click="$emit('click')"
    :style="'height:'+inputHeight+'px;width:'+(
      isNaN(inputWidth)
        ?inputWidth.includes('%')?inputWidth:'100%'
        :inputWidth+'px'
    )">
    <div class="input-box df-c-fs" ref="box">
      <span class="cursor-blink" :class="{'placeholder':isPlaceholder,'inputable':inputable}">{{inputValueHtml}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputCustom',
  props: {
    // 输入值
    inputValue: String,
    // 占位文本
    inputPlaceholder: String,
    // 输入框宽度
    inputWidth: {
      type: [Number, String],
      default: '100%'
    },
    // 输入框高度
    inputHeight: {
      type: [Number, String],
      default: 50
    },
    // 是否支持输入
    inputable: {
      type: Boolean,
      default: false
    },
    // 是否是密码框
    showPassword: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isPlaceholder: false,
    }
  },
  computed: {
    inputValueHtml() {
      if (this.inputValue) {
        if (this.showPassword) {
          return '*'.repeat(this.inputValue.length)
        } else{
          return this.inputValue
        }
      } else if (this.inputPlaceholder) {
        return this.inputPlaceholder
      }
    },
  },
  watch: {
    inputValue(n, o) {
      let el = this.$refs.box
      el.scrollLeft = el.scrollWidth
      // console.log(el.scrollLeft, el.scrollWidth)

      // console.log(n, isNaN(n))
      this.isPlaceholder = (isNaN(n) || n === '') && n !== '-'
    }
  },
  created() {
    // console.log(this.inputValue, isNaN(this.inputValue) || this.inputValue === '')
    this.isPlaceholder = (isNaN(this.inputValue) || this.inputValue === '') && this.inputValue !== '-'
  },
}
</script>

<style lang="scss" scoped>
.input-border{
  padding: 0 14px;background: #fff;border-radius: 4px;box-sizing: border-box;
  border: 1px solid #374978;
  // border: 1px solid #979797;
  &.active{border-width: 2px;}
  .input-box{
    overflow-x: auto;height: 100%;
    .cursor-blink{
      display: inline-block;height: 32px;line-height: 32px;
      padding-right: 10px;word-break: keep-all;position: relative;
      &.inputable::after {
        content: '';display: inline-block;width: 1px;height: 24px;
        position: absolute;top: 0;bottom: 0;margin: auto;
        animation: blink 1.06s infinite steps(1, start);
      }
      &.inputable.placeholder::after {left: 0;}
    }
  }
}
/*这里设置动画blink*/
@keyframes blink {
  0%, 100% {
    background-color: #fff;
    color: #fff;
  }
  50% {
    background-color: #000; /* not #aaa because it's seem there is Google Chrome bug */
    color: #000;
  }
}
</style>